import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
    TabbedComponent,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useOrganization} from '../hooks/useOrganization.ts';
import {useOrganizationsSelection} from '../hooks/useOrganizationsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {useOrganizations} from "../hooks/useOrganizations.ts";

import {OrganizationMembersTab} from "../../organization-accounts/components/OrganizationMembersTab.tsx";
import {useOrganizationAccounts} from "../../organization-accounts/hooks/useOrganizationAccounts.ts";


export const EditPage = () => {

    const {id: organizationId} = useParams();

    if (typeof organizationId === 'undefined') {
        throw new Error('organizationId is required parameter');
    }

    const {fetchRecords} = useOrganizations();

    const {
        record: organization,
        fetchRecord,
        updateRecord,
    } = useOrganization(organizationId);

    const {handleClearSelection} = useOrganizationsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchRecords({});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchRecord();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    const {data: orgAccounts} = useOrganizationAccounts(organizationId);
    const memberCount = orgAccounts?.items?.length;

    if (!organization) {
        return <PlatformLoader message='Loading organization...Please wait'/>;
    }

    const tabs = []

    tabs.push({
                  title: memberCount !== undefined ? `Members (${memberCount})` : 'Members',
                  component: <OrganizationMembersTab organizationId={organizationId}/>
              })

    return (
        <FormPageLayout
            title={organization.name ? organization.name : organization.id}
            pageNavigation={<EditPageNavigation component={organization}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 5
                    }}>
                        <Profile record={organization}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 7
                    }}>
                        <SimplePageContentWrapper>
                            <TabbedComponent tabs={tabs}></TabbedComponent>
                        </SimplePageContentWrapper>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={organization}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
